import React, { useState } from 'react';
import { PageSection, Title, Grid, GridItem } from '@patternfly/react-core';
import './usage-analytics.css';
import { SimpleSelect } from '@patternfly/react-templates';
import { EventTimeSeriesChart } from './components/EventTimeSeriesChart';
import { ModuleTimeSeriesChart } from './components/ModuleTimeSeriesChart';
import { TopUsersTable } from './components/TopUsersTable';
import { PageViewsChart } from './components/PageViewsChart';
import { useClusters, useEventNames } from './hooks/useUsageAnalytics';

export const UsageAnalyticsPage: React.FC = () => {
  const [cluster, setCluster] = useState<string | null>(null);
  const { clusters } = useClusters();
  const { eventNames } = useEventNames();

  const clusterOptions = [
    { value: '', content: 'All clusters' },
    ...clusters.map((c) => ({ value: c, content: c })),
  ];

  return (
    <PageSection>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 24 }}>
        <Title headingLevel="h1" size="xl" style={{ margin: 0 }}>
          Usage Analytics
        </Title>
        {clusters.length > 0 && (
          <div style={{ minWidth: 200 }}>
            <SimpleSelect
              initialOptions={clusterOptions}
              onSelect={(_e, value) => setCluster((value as string) || null)}
              placeholder="All clusters"
            />
          </div>
        )}
      </div>
      <Grid hasGutter>
        <GridItem span={12}>
          <EventTimeSeriesChart cluster={cluster} />
        </GridItem>
        <GridItem span={12}>
          <ModuleTimeSeriesChart cluster={cluster} />
        </GridItem>
        <GridItem span={12}>
          <TopUsersTable eventNames={eventNames} cluster={cluster} />
        </GridItem>
        <GridItem span={12}>
          <PageViewsChart cluster={cluster} />
        </GridItem>
      </Grid>
    </PageSection>
  );
};

